(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ej-grid-insert')) {
    const inserts = new Set();
    const designMode = Boolean(window.Shopify && Shopify.designMode);
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    let moving = false;
    let frame = 0;
    let observedGrid = null;
    let observedWidth = 0;

    const round = (value) => `${Math.round(value * 100) / 100}`;

    const setVar = (element, name, value) => {
      if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
    };

    const isDefaultView = (insert) => {
      const params = new URLSearchParams(window.location.search);
      for (const [key, value] of params) {
        if (key.startsWith('filter.') && value !== '') return false;
      }
      const sort = params.get('sort_by');
      if (sort && sort !== insert.dataset.defaultSort) return false;
      return (Number(params.get('page')) || 1) === 1;
    };

    const measure = (grid, products) => {
      const gridBox = grid.getBoundingClientRect();
      const first = products[0].getBoundingClientRect();
      if (!first.width) return null;
      const second = products[1]?.getBoundingClientRect();
      const columns = Math.max(1, Math.round(gridBox.width / first.width));
      const pitch = second && Math.abs(second.top - first.top) < 1 ? second.left - first.left : first.width;
      const inset = parseFloat(getComputedStyle(products[0]).paddingLeft) || 0;
      return {
        columns,
        start: first.left + inset - gridBox.left,
        end: Math.max(0, gridBox.right - (first.left + (columns - 1) * pitch + first.width)),
        gap: pitch - first.width + inset,
      };
    };

    const overlay = (insert) => {
      const section = document.getElementById(`shopify-section-${insert.dataset.sectionId}`);
      if (!section) return;
      if (!insert.hasAttribute('data-placed')) {
        ['position', 'top', 'left', 'width', 'height', 'pointer-events'].forEach((name) => section.style.removeProperty(name));
        return;
      }
      section.style.position = 'absolute';
      section.style.pointerEvents = 'none';
      const host = section.offsetParent;
      const positioned = host && getComputedStyle(host).position !== 'static';
      const origin = positioned ? host.getBoundingClientRect() : { top: -window.scrollY, left: -window.scrollX };
      const box = insert.getBoundingClientRect();
      section.style.top = `${box.top - origin.top - (positioned ? host.clientTop : 0)}px`;
      section.style.left = `${box.left - origin.left - (positioned ? host.clientLeft : 0)}px`;
      section.style.width = `${box.width}px`;
      section.style.height = `${box.height}px`;
    };

    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        place();
      });
    };

    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      if (width === observedWidth && !designMode) return;
      observedWidth = width;
      schedule();
    });

    const observe = (grid) => {
      if (grid === observedGrid) return;
      observer.disconnect();
      observedGrid = grid;
      observedWidth = 0;
      if (grid) observer.observe(grid);
    };

    const place = () => {
      const grid = document.querySelector('#CollectionAjaxContent .grid--uniform');
      const products = grid ? Array.from(grid.querySelectorAll(':scope > [data-product-id]')) : [];
      const layout = products.length ? measure(grid, products) : null;

      inserts.forEach((insert) => {
        if (!insert.home.isConnected) inserts.delete(insert);
      });
      const ordered = Array.from(inserts).sort((a, b) =>
        a.home.compareDocumentPosition(b.home) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
      const placed = new Set();

      moving = true;
      ordered.forEach((insert) => {
        if (!layout || !isDefaultView(insert)) {
          if (insert.parentElement !== insert.home) insert.home.append(insert);
          insert.removeAttribute('data-placed');
          return;
        }

        const row = Number(mobileQuery.matches ? insert.dataset.mobileRow : insert.dataset.desktopRow) || 1;
        const rowEnd = Math.min(row * layout.columns, products.length);
        let anchor = products[rowEnd - 1];
        while (placed.has(anchor.nextElementSibling)) anchor = anchor.nextElementSibling;
        if (anchor.nextElementSibling !== insert) anchor.after(insert);

        insert.setAttribute('data-placed', '');
        setVar(insert, '--ej-grid-insert-start', `${round(layout.start)}px`);
        setVar(insert, '--ej-grid-insert-end', `${round(layout.end)}px`);
        setVar(insert, '--ej-grid-insert-gap', `${round(layout.gap)}px`);
        setVar(insert, '--ej-grid-insert-columns', `${layout.columns}`);
        placed.add(insert);
      });
      moving = false;

      if (designMode) ordered.forEach(overlay);
      observe(grid);
    };

    document.addEventListener('collection:reloaded', place);
    window.addEventListener('popstate', schedule);
    mobileQuery.addEventListener('change', schedule);

    if (designMode) {
      document.addEventListener('shopify:section:unload', (event) => {
        inserts.forEach((insert) => {
          if (insert.dataset.sectionId !== event.detail.sectionId) return;
          inserts.delete(insert);
          insert.remove();
        });
      });

      document.addEventListener('shopify:section:load', place);
    }

    customElements.define(
      'ej-grid-insert',
      class extends HTMLElement {
        connectedCallback() {
          if (moving) return;
          this.home ||= this.parentElement;
          inserts.add(this);
          place();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ej-guide-tabs')) {
    class EjGuideTabs extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onHashChange = this.onHashChange.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        window.addEventListener('hashchange', this.onHashChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.applyHash();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHashChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      tabsIn(list) {
        return Array.from(list.children).filter((el) => el.getAttribute('role') === 'tab');
      }

      mainList() {
        return this.querySelector('.ej-guides__tablist');
      }

      select(tab, { focus = false, updateHash = false } = {}) {
        const list = tab.parentElement;
        this.tabsIn(list).forEach((item) => {
          const on = item === tab;
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (list === this.mainList()) this.reveal(tab, list);
        if (focus) tab.focus({ preventScroll: true });
        if (updateHash) history.replaceState(null, '', '#' + this.hashFor(tab));
      }

      reveal(tab, list) {
        if (list.scrollWidth <= list.clientWidth) return;
        const box = list.getBoundingClientRect();
        const item = tab.getBoundingClientRect();
        const pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
        if (item.left >= box.left + pad && item.right <= box.right - pad) return;
        list.scrollBy({ left: item.left - box.left - (box.width - item.width) / 2, behavior: 'smooth' });
      }

      hashFor(tab) {
        const panel = tab.closest('[data-ej-panel]');
        if (panel && tab.classList.contains('ej-guides__subtab')) {
          return panel.dataset.slug + '/' + tab.dataset.slug;
        }
        return tab.dataset.slug;
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.select(tab, { updateHash: true });
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        const tabs = this.tabsIn(tab.parentElement);
        const index = tabs.indexOf(tab);
        const keys = {
          ArrowRight: index + 1,
          ArrowDown: index + 1,
          ArrowLeft: index - 1,
          ArrowUp: index - 1,
          Home: 0,
          End: tabs.length - 1
        };
        if (!(event.key in keys)) return;
        if (tab.classList.contains('ej-guides__tab') && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) return;
        event.preventDefault();
        const next = tabs[(keys[event.key] + tabs.length) % tabs.length];
        this.select(next, { focus: true, updateHash: true });
      }

      applyHash() {
        const list = this.mainList();
        const hash = decodeURIComponent(window.location.hash.slice(1));
        if (!hash) return;
        const [mainSlug, subSlug] = hash.split('/');
        let scope = this;
        if (list) {
          const tab = this.tabsIn(list).find((item) => item.dataset.slug === mainSlug);
          if (!tab) return;
          this.select(tab);
          scope = document.getElementById(tab.getAttribute('aria-controls'));
        }
        if (!subSlug || !scope) return;
        const sub = Array.from(scope.querySelectorAll('.ej-guides__subtab')).find((item) => item.dataset.slug === subSlug);
        if (sub) this.select(sub);
      }

      onHashChange() {
        this.applyHash();
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const subpanel = event.target.closest('[data-ej-subpanel]');
        const panel = event.target.closest('[data-ej-panel]');
        [panel, subpanel].forEach((target) => {
          if (!target || !target.id) return;
          const tab = this.querySelector('[aria-controls="' + target.id + '"]');
          if (tab) this.select(tab);
        });
      }
    }

    customElements.define('ej-guide-tabs', EjGuideTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
